import { Component, OnInit, inject, signal } from '@angular/core';
import { OutcomeScreenComponent } from '../../shared/components/outcome-screen/outcome-screen.component';
import { VisitService } from '../../core/visit/visit.service';

@Component({
  selector: 'app-visitor-welcome',
  standalone: true,
  imports: [OutcomeScreenComponent],
  templateUrl: './visitor-welcome.component.html',
  styleUrl: './visitor-welcome.component.scss',
})
export class VisitorWelcomeComponent implements OnInit {
  private readonly visitService = inject(VisitService);

  readonly visitorName = signal<string>('');

  ngOnInit(): void {
    const current = this.visitService.current();
    if (!current) return;
    this.visitorName.set(current.visitor.firstName + ' ' + current.visitor.lastName);
    // La visite est enregistrée dès l'affichage de la confirmation (la
    // notification est partie) : le parcours est terminé, d'où `OnClick`. Le nom
    // est lu avant, `endVisit()` vide la session courante. Seule une sortie par
    // inactivité, sans confirmation, reste enregistrée en `Auto`.
    void this.visitService.endVisit('OnClick');
  }
}
